module.exports = {"350502001":"海滨街道","350502002":"临江街道","350502003":"鲤中街道","350502004":"开元街道","350502005":"浮桥街道","350502006":"江南街道","350502007":"金龙街道","350502008":"常泰街道","350502400":"清濛经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350502.json
// module id = 1308
// module chunks = 0